import { render, staticRenderFns } from "./Pretest.vue?vue&type=template&id=1830922b&"
import script from "./Pretest.vue?vue&type=script&lang=js&"
export * from "./Pretest.vue?vue&type=script&lang=js&"
import style0 from "./Pretest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports